var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-8",
    transform: "translate(-1351, -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1351, 95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E3E3E3",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-user-1994976",
    transform: "translate(11, 8)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2037534,10.0575107 C12.075067,9.96717022 11.924933,9.98975534 11.8176944,10.0800958 C10.7453083,10.9157451 9.43699732,11.3900326 8,11.3900326 C6.56300268,11.3900326 5.25469169,10.89316 4.18230563,10.0800958 C4.07506702,9.98975534 3.90348525,9.98975534 3.79624665,10.0575107 C1.26541555,11.7739796 0,15.1391621 0,19.0012171 C0,21.666261 16,21.666261 16,19.0012171 C16,15.1391621 14.7345845,11.7739796 12.2037534,10.0575107 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 5,
    r: 5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconBlue);
export default __webpack_public_path__ + "static/media/user-icon--blue.7198c06c0cc53c39a3617dfb79059abd.svg";
export { ForwardRef as ReactComponent };